/* eslint-disable */
import request from './helpers'

export function getSentinelSummary() {
  return request({
    url: '/api/v1/sentinel/sentinel/summary',
    method: 'get'
  })
};

export function getAllocationSummary() {
  return request({
    url: '/api/v1/sentinel/allocation/summary',
    method: 'get'
  })
};

export function getResourceSummary() {
  return request({
    url: '/api/v1/sentinel/resource/summary',
    method: 'get'
  })
};

export function getBrokerSummary() {
  return request({
    url: '/api/v1/sentinel/broker/summary',
    method: 'get'
  })
}
